export enum LoginScreenForms {
  LOGIN = 'login',
  RECOVER = 'recover',
  REGISTER = 'register',
}
